import { render, staticRenderFns } from "./CompanyModule.vue?vue&type=template&id=b7d31510&"
import script from "./CompanyModule.vue?vue&type=script&lang=ts&"
export * from "./CompanyModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports